import HttpHelper from '@/helpers/http';
import { ITheme } from '@/helpers/theme';

export interface IThemeResponse {
  success: boolean;
  themes: ITheme[];
}

export interface IStreamLabelResponse {
  success: boolean;
  data: any;
}

export default class StreamlabsApi {
  static async getThemes(): Promise<IThemeResponse> {
    return await HttpHelper.get('/api/v1/themes');
  }

  static async getStreamLabelData(): Promise<IStreamLabelResponse> {
    return await HttpHelper.get('/api/v1/stream-labels', { background: true });
  }

  static async getStreamLabelDataByToken(token: string, sessionId: string = null): Promise<IStreamLabelResponse> {
    return await HttpHelper.get(`/api/v1/users/${token}/stream-labels${sessionId ? `?session_id=${sessionId}` : ''}`, { background: true });
  }
}
